import {FollowUpRecordType} from "@core/domain/supply-chain";

export default {
    methods: {
        resolveType(record) {
            if (record.type === 'note') {
                return 'note';
            } else if (record.type === 'supplier_email') {
                return 'email';
            } else if (this.isReplyToSupplierEmail(record)) {
                return 'reply';
            }
            return 'unknown';
        },
        isNote(record) {
            return record.type === FollowUpRecordType.NOTE;
        },
        isSupplierEmail(record) {
            return record.type === FollowUpRecordType.SUPPLIER_EMAIL;
        },
        isReplyToSupplierEmail(record) {
            return record.type === FollowUpRecordType.REPLY_TO_SUPPLIER_EMAIL;
        },
    }
}
